export function generateRandomId() {
  return Math.random().toString(36).slice(2);
}

export function compareObjects<T>(obj1: T, obj2: any): boolean {
  // DEBUG: Log initial comparison

  if (obj1 === obj2) {
    return true;
  }

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false;
  }

  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) {
      return false;
    }

    for (const [elementIndex, element] of obj1.entries()) {
      if (!compareObjects(element, obj2[elementIndex])) {
        return false;
      }
    }

    return true;
  }

  if (obj1 instanceof Date && obj2 instanceof Date) {
    return obj1.getTime() === obj2.getTime();
  }

  const keysA = Object.keys(obj1) as (keyof T)[];
  const keysB = Object.keys(obj2) as (keyof T)[];

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (!keysB.includes(key)) {
      return false;
    }

    const val1 = obj1[key];
    const val2 = obj2[key];

    if (typeof val1 === 'function' || typeof val2 === 'function') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
      if ((val1 as Function).toString() !== (val2 as Function).toString()) {
        return false;
      }
    } else if (!compareObjects(val1, val2)) {
      return false;
    }
  }

  return true;
}
